import { z } from 'zod';

import { gameOverviewCrestSchema } from './game-overview.schema';

export const teamPossessionSchema = z
	.object({
		id: z.union([z.number(), z.string()]).nullable().optional(),
		title: z.string().optional(),
		value: z.union([z.number(), z.string()]).optional(),
	})
	.passthrough();

export const teamShotsSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		title: z.string().optional(),
		value: z.union([z.number(), z.string()]).optional(),
		relatedPercentile: z.union([z.number(), z.string()]).optional(),
	})
	.passthrough();

export const teamStatDetailSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		title: z.string().optional(),
		value: z.union([z.number(), z.string()]).optional(),
		relatedPercentile: z.union([z.number(), z.string()]).optional(),
	})
	.passthrough();

export const teamCardsSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		title: z.string().optional(),
		redCards: z.number().optional(),
		yellowCards: z.number().optional(),
	})
	.passthrough();

export const teamDetailStatsSchema = z
	.object({
		name: z.string().optional(),
		shortName: z.string().optional(),
		teamColour: z.string().optional(),
		possession: teamPossessionSchema.optional(),
		shots: z.array(teamShotsSchema).optional(),
		stats: z.array(teamStatDetailSchema).optional(),
		cards: teamCardsSchema.optional(),
		crest: gameOverviewCrestSchema.optional(),
	})
	.passthrough();

export const teamStatsSchema = z
	.object({
		homeTeam: teamDetailStatsSchema.optional(),
		awayTeam: teamDetailStatsSchema.optional(),
		sponsor: z.unknown().optional(),
	})
	.passthrough();

export type TeamPossession = z.infer<typeof teamPossessionSchema>;
export type TeamShots = z.infer<typeof teamShotsSchema>;
export type TeamStatDetail = z.infer<typeof teamStatDetailSchema>;
export type TeamCards = z.infer<typeof teamCardsSchema>;
export type TeamDetailStats = z.infer<typeof teamDetailStatsSchema>;
export type TeamStats = z.infer<typeof teamStatsSchema>;
